/** Active departments shown in claim updates, payments, and timeline filters. */
export const ACTIVE_DEPARTMENTS = [
  "office",
  "more_documents",
  "supplementing",
  "checks",
  "inspections",
  "claim_updates",
  "appraisal",
  "only_urgent",
  "attorney_update",
  "guilfe",
];

/** All departments available for user profile assignment. */
export const ALL_DEPARTMENTS = [
  ...ACTIVE_DEPARTMENTS,
  "intake",
  "check_support",
  "management",
  "roofer_relations",
  "estimation",
  "sales",
  "stanley",
  "developer",
];

export function getActiveDepartmentOptions(t, i18nPrefix) {
  return ACTIVE_DEPARTMENTS.map((value) => ({
    text: t(`${i18nPrefix}.${value}`),
    value,
  }));
}

export function getAllDepartmentOptions(t, i18nPrefix) {
  return ALL_DEPARTMENTS.map((value) => ({
    text: t(`${i18nPrefix}.${value}`),
    value,
  }));
}
